import * as y from 'yup'

export const MIN_8_MAX_20_CHARS = /^.{8,20}$/
export const ONE_UPPER = /(?=.*[A-Z])/
export const ONE_LOWER = /(?=.*[a-z])/
export const ONE_NUMBER = /(?=.*\d)/
export const NO_BANNED_CHARS = /^[^_/\\“”"'‘’`<>,\s]*$/
export const EMAIL_DOMAIN_NAME = /@.+\..+/

// Regex used by yup.email() validation
// /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
export const EMAIL_PATTERN =
  /^[a-zA-ZÀ-Ÿ0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-ZÀ-Ÿ0-9](?:[a-zA-ZÀ-Ÿ0-9-]{0,61}[a-zA-ZÀ-Ÿ0-9])?(?:\.[a-zA-ZÀ-Ÿ0-9](?:[a-zA-ZÀ-Ÿ0-9-]{0,61}[a-zA-ZÀ-Ÿ0-9])?)*$/

export const schema = y.object({
  email: y
    .string()
    .max(50, 'email.invalid')
    .matches(EMAIL_PATTERN, 'email.invalid')
    .matches(EMAIL_DOMAIN_NAME, 'email.invalid'),
  password: y
    .string()
    .optional()
    .matches(MIN_8_MAX_20_CHARS, 'password.invalid')
    .matches(ONE_UPPER, 'password.invalid')
    .matches(ONE_LOWER, 'password.invalid')
    .matches(ONE_NUMBER, 'password.invalid')
    .matches(NO_BANNED_CHARS, 'password.invalid'),
})

export type Schema = y.InferType<typeof schema>
